import { render, staticRenderFns } from "./departmentListComponent.vue?vue&type=template&id=49ba9cb1&scoped=true&"
import script from "./departmentListComponent.vue?vue&type=script&lang=js&"
export * from "./departmentListComponent.vue?vue&type=script&lang=js&"
import style0 from "./departmentListComponent.vue?vue&type=style&index=0&id=49ba9cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba9cb1",
  null
  
)

export default component.exports